import { WIDGET_COOKIE_NAME, type WidgetUser } from '@/config';

export default function getWidgetCookie(): WidgetUser | null {
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${WIDGET_COOKIE_NAME}=`));

  if (!match) return null;

  try {
    return JSON.parse(decodeURIComponent(match.split('=').slice(1).join('=')));
  } catch {
    return null;
  }
}
